/* eslint-disable prettier/prettier */
/**
 * Regular Expression constants
 */

// Phone number validation RegExp constants
export const PHONE_REGEXP = {
  // 10-digit NANP: area + exchange cannot start with 0/1
  US_10DIGITS: /^(?<area_code>[2-9](?!11)\d{2})(?<exchange_code>[2-9](?!11)\d{2})(?<last_four>\d{4})$/,

  // 11-digit NANP with country code 1
  US_11DIGITS: /^(?<country_code>1)(?<area_code>[2-9](?!11)\d{2})(?<exchange_code>[2-9](?!11)\d{2})(?<last_four>\d{4})$/,

  FILTER_VALID_CHAR: /[$&,:;=?@#|'<>.^*{}[\]`%!~]/ /* To check only valid characters */,
  FILTER_NUMBERS: /\D/g /* To check only valid numbers */,
};

// Password validation RegExp constants
export const PASSWORD_REGEXP = {
    SYMBOL: '[!@#$%^&*]' /* to check password contains any symbols */,
    UPPERCASE: /\p{Lu}/u /* to check password contains any upper case letter */,
    NUMBERS: '[0-9]' /* to check password contains any numbers */,
};

// Password validation constants as pure regex for validator consumption
export const PASSWORD_REGEXP_EXPRESSIONS = {
  SYMBOL: /[!@#$%^&*]/u /* to check password contains any symbols */,
  UPPERCASE: /\p{Lu}/u /* to check password contains any upper case letter */,
  NUMBERS: /\d/u /* to check password contains any numbers */,
};
